import { Button } from '@mui/material';

import FeatureCard from '../components/feature-card';
import Question1 from '../components/question1';
import './home.css';

const Home = (props) => {
    return (
        <div className="home-container">
            <div className="home-hero">
                <div className="heroContainer home-hero1">
                    <div className="home-container1">
                        <h1 className="home-hero-heading">
                            <span className="heading1 home-text">
                                Proste zarządzanie urlopami
                            </span>
                            <br></br>
                        </h1>
                        <span className="home-hero-sub-heading bodyLarge">
                            <span>
                                <span>
                                    <span>
                                        Łatwe zarządzanie czasem wolnym i
                                        dostępem do ważnych dokumentów
                                    </span>
                                    <span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: ' ',
                                            }}
                                        />
                                    </span>
                                </span>
                                <span>
                                    <span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: ' ',
                                            }}
                                        />
                                    </span>
                                    <span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: ' ',
                                            }}
                                        />
                                    </span>
                                </span>
                            </span>
                            <span>
                                <span>
                                    <span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: ' ',
                                            }}
                                        />
                                    </span>
                                    <span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: ' ',
                                            }}
                                        />
                                    </span>
                                </span>
                                <span>
                                    <span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: ' ',
                                            }}
                                        />
                                    </span>
                                    <span>
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: ' ',
                                            }}
                                        />
                                    </span>
                                </span>
                            </span>
                        </span>
                        <div className="home-btn-group">
                            <Button
                                className="buttonFilled"
                                href="/absenceList"
                            >
                                Zacznij tutaj
                            </Button>
                            <a className="buttonFlat">Dowiedz się więcej→</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="home-features">
                <div className="featuresContainer">
                    <div className="home-features1">
                        <div className="home-container2">
                            <span className="overline">Główne ceCHY</span>
                            <h2 className="home-features-heading heading2">
                                Usprawnij procesy dzięki naszej aplikacji.
                            </h2>
                            <span className="home-features-sub-heading bodyLarge">
                                <span>
                                    <span>
                                        <span>
                                            Odkryj kluczowe funkcje, które
                                            sprawiają, że nasza aplikacja HR
                                            jest niezbędna dla Twojej
                                            organizacji.
                                        </span>
                                        <span>
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: ' ',
                                                }}
                                            />
                                        </span>
                                    </span>
                                    <span>
                                        <span>
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: ' ',
                                                }}
                                            />
                                        </span>
                                        <span>
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: ' ',
                                                }}
                                            />
                                        </span>
                                    </span>
                                </span>
                                <span>
                                    <span>
                                        <span>
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: ' ',
                                                }}
                                            />
                                        </span>
                                        <span>
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: ' ',
                                                }}
                                            />
                                        </span>
                                    </span>
                                    <span>
                                        <span>
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: ' ',
                                                }}
                                            />
                                        </span>
                                        <span>
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: ' ',
                                                }}
                                            />
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </div>
                        <div className="home-container3">
                            <FeatureCard
                                to="/absenceList"
                                heading="Zarządzanie swoimi nieobecnościami"
                                subHeading="Ten moduł umożliwia pracownikom zgłaszanie planowanych nieobecności oraz wnioskowanie o urlopy w sposób łatwy i wygodny. Dzięki niemu można szybko i sprawnie zarządzać swoim czasem pracy, co przyczynia się do efektywności całego zespołu"
                            ></FeatureCard>
                        </div>
                    </div>
                </div>
            </div>
            <div className="home-pricing"></div>
            <div className="home-banner">
                <div className="bannerContainer home-banner1">
                    <h1 className="home-banner-heading heading2">
                        Usprawnij procesy HR
                    </h1>
                    <span className="home-banner-sub-heading bodySmall">
                        <span>
                            <span>
                                <span>
                                    Nasza aplikacja HR pozwala łatwo wprowadzać
                                    czas wolny, pobierać niezbędne dokumenty i
                                    zwiększać ogólną wydajność w Twojej
                                    organizacji. Pożegnaj się z ręczną
                                    papierkową robotą i przywitaj nowoczesną
                                    aplikacje.
                                </span>
                                <span>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: ' ',
                                        }}
                                    />
                                </span>
                            </span>
                            <span>
                                <span>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: ' ',
                                        }}
                                    />
                                </span>
                                <span>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: ' ',
                                        }}
                                    />
                                </span>
                            </span>
                        </span>
                        <span>
                            <span>
                                <span>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: ' ',
                                        }}
                                    />
                                </span>
                                <span>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: ' ',
                                        }}
                                    />
                                </span>
                            </span>
                            <span>
                                <span>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: ' ',
                                        }}
                                    />
                                </span>
                                <span>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: ' ',
                                        }}
                                    />
                                </span>
                            </span>
                        </span>
                    </span>
                    <button className="buttonFilled">
                        <a href="/help">
                            <span>Dowiedz się wiecej</span>
                            <br></br>
                        </a>
                    </button>
                </div>
            </div>
            <div className="home-footer">
                <footer className="footerContainer home-footer1">
                    <div className="home-container6">
                        <a className="logo"></a>
                        <nav className="home-nav1"></nav>
                    </div>
                    <div className="home-separator"></div>
                    <div className="home-container7">
                        <span className="bodySmall home-text56">
                            © 2024 AgemaHR, All Rights Reserved.
                        </span>
                        <div className="home-icon-group1"></div>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default Home;
